import useSortedPerAvailabilityList from '../hooks/use-sorted-per-availability-list';

export const getSortedGroups = <T extends TCategories | TPart[]>(
  groups: T
): T => {
  let groupsSort: TCategories = [];
  groupsSort = useSortedPerAvailabilityList(groups) as TCategories;

  groupsSort.map((group) => {
    const partsSort = Object.entries(group.parts).reduce(
      (finalParts, [partIndex, parts]) => {
        const sortedParts = useSortedPerAvailabilityList(parts);
        return { ...finalParts, [partIndex]: sortedParts };
      },
      {} as typeof group.parts
    );

    return { ...group, parts: partsSort };
  });

  return groupsSort as T;
};

export const getSortedProductsPerGroups = <T extends TCategories | TPart[]>(
  groups: T
): T => {
  let groupsSort: TCategories = [];
  groupsSort = useSortedPerAvailabilityList(groups) as TCategories;

  return groupsSort as T;
};
